export default __webpack_public_path__ + "static/media/frg--outdoor-cinema.3aad09a3.png";